export default __webpack_public_path__ + "static/media/info.da9eaac6.svg";